import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { ConnectionContext } from "../contexts/ConnectionProviderContext";
import { PublicKey } from "@solana/web3.js";
import DeleteIcon from "../assets/delete.svg";
import LikeIcon from "../assets/like-active.svg";
import NotLikedIcon from "../assets/like-inactive.svg";
import { TweeterDapp } from "../types/tweeter_dapp";
import { Program, web3 } from "@project-serum/anchor";
import { TweetsContext } from "../contexts/TweetsContext";
import { LikeContext } from "../contexts/LikesContext";
import { useWallet } from "@solana/wallet-adapter-react";

dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
const TweetsContainer = (props: any) => {
  const likeAccount = web3.Keypair.generate();
  const tweets = props?.tweets?.sort((a: any, b: any) => b.account?.timestamp.toNumber() - a.account?.timestamp.toNumber());
  const { workSpace }: any = useContext(ConnectionContext);
  const wallet = workSpace.wallet;
  const program = workSpace.program as Program<TweeterDapp>;
  const connection = workSpace.connection;
  const { setPage} = useContext(TweetsContext);
  const {setFetch} = useContext(LikeContext);
  const userWallet = useWallet();
  const deleteTweetHandler = async (key: PublicKey) => {
    try {
      // console.log("KEYS", key.toString());
      await program.methods
        .deleteTweet()
        .accounts({
          tweet: key,
          author: wallet.publicKey,
        })
        .rpc();

      setFetch();

    } catch (error) {
      console.log("Error in Deleting", error);
    }
  };

  const dislikeHandler = async (key: PublicKey) => {
    // console.log("DISLIKE", key.toString());
   
    try {
      await program.methods.dislikeTweet().accounts({
        like: key,
        author: wallet.publicKey
      }).rpc();
      setFetch();
    }catch (error) {
      console.log("Error in Disliking", error);
    }
  }

  const loadMoreHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setPage();
  };

  const likeHandler = async (author: PublicKey) => {
    // console.log("LIKEHANDLER", author.toString(), wallet.publicKey.toString(), userWallet.publicKey?.toStr);
    if(!userWallet.publicKey) {
      alert("Connect your wallet! 🚀🚀");
      return;
    }

    if(userWallet) {
      try {
        
        const balance = await connection.getBalance(userWallet.publicKey);
        const balanceInSol = balance && balance / web3.LAMPORTS_PER_SOL;
        if(balanceInSol < 0.001) {
          alert(` Your wallet balance is low - ${balanceInSol}. "AIRDROP" some SOL from here 👉 - https://solfaucet.com/ .`);
          return;
        }
      } catch (error) {
        alert("Devnet connection unstable. Please try again.")
        console.log("Error", error);
      }
    }
    try {
      await program.methods.likeTweet(author).accounts({
        like: likeAccount.publicKey,
        author: wallet.publicKey,
        systemProgram: web3.SystemProgram.programId
      }).signers([likeAccount]).rpc();
      setFetch();
    } catch (err) {
      console.log("Something went wrong", err)
    }
    // console.log("AUTHOR", author.toString())
  }
  const isAuthor = (pubKey: PublicKey) => {
    if (pubKey === wallet.publicKey.toString()) {
      return { name: "profile" };
    } else {
      return { name: "user", params: { author: pubKey } };
    }
  };
  return (
    <>
      <section className="border-l-2 border-r-2 border-t-2 border-t-gray-300 border-l-gray-300 border-r-gray-300 row-span-2 col-start-5 col-span-4 mt-2 mb-4 md:mb-4">
        {tweets.length > 0 && 
          tweets.map((tweet: any, idx: number) => {
            // console.log("TWEETS-CONTAINER", tweets);
            const author =
              tweet.author?.toString() || tweet.account.author?.toString();
            const tweetKey = tweet.publicKey || tweet.account.publicKey;
            
            const author_display =
              author.slice(0, 4) + "..." + author.slice(-3);
            const content = tweet.content || tweet.account?.content;
            const timeFromNow = dayjs
              .unix(
                tweet.timestamp?.toNumber() ||
                tweet.account?.timestamp.toNumber()
              )
              .fromNow();
            const time_display = dayjs.unix(
              tweet.timestamp?.toNumber() ||
              tweet.account?.timestamp.toNumber()
            ).format('DD/MM/YY');
            // console.log("TIME", time_display);
            const topic = tweet.topic || tweet.account?.topic;
            const keys = tweet.publicKey.toString();
            const authorLink = isAuthor(author);
            const likes = tweet.likes;
            const likesAddress = tweet.likesAddress;
            const likedByUser = tweet.likedByUser;
            
            // console.log("AUTHOR LINK", authorLink.name, authorLink?.params?.author )
            return (
              <div
                key={keys}
                className="border-b-2 border-b-gray-300 px-2 py-1"
              >
                <div className="flex space-x-3 items-center justify-between">
                  <div className="flex space-x-3 items-center">
                    <Link
                      to={`/${authorLink.name}/${authorLink?.params?.author}`}
                      className="hover:ease-in-out hover:delay-75 hover:scale-110 "
                    >
                      {" "}
                      <h2 className="font-bold text-base">{author_display}</h2>
                    </Link>
                    <span className="font-light text-sm text-slate-600">
                      {timeFromNow}
                    </span>
                  </div>
                  {author === wallet.publicKey.toString() && (
                    <button
                      onClick={() => deleteTweetHandler(tweet.publicKey)}
                      className="hover:bg-rose-400 hover:rounded-md"
                    >
                      <img
                        className="h-6"
                        src={DeleteIcon}
                        alt="delete button icon"
                      />
                    </button>
                  )}
                </div>
                <p className="pt-2 text-sm md:text-base">{content}</p>
                <div className="pt-2 flex justify-between items-baseline">
                  <Link
                    to={`/topic/${topic}`}
                    className="hover:ease-in-out hover:delay-75 hover:scale-110"
                  >
                    <span className="text-xs md:text-sm text-blue-400">
                      #{topic}
                    </span>
                  </Link>
                  <div className="flex items-center">
                    {/* {likedTweet?.length > 0 && <span>Got a like!!!</span>} */}
                    {likedByUser && <button onClick={() => dislikeHandler(likesAddress)}><img src={LikeIcon} alt="heart"></img></button>}
                    {!likedByUser && <button onClick={() => likeHandler(tweetKey)}><img src={NotLikedIcon} alt="heart"></img></button>}
                    {<span className="pl-1">{likes}</span>}
                  </div>
                  {/* {
                    userLikes.length > 0 &&
                    userLikes.map((likes: any) => {
                      const user = likes.account?.author.toString();
                      let like = 0 || likes.account?.likes;
                      return (
                        <div className="flex items-center">
                          {user === wallet.publicKey.toString() && <button onClick={() => { }}><img src={LikeIcon} alt="heart"></img></button>}
                          {user !== wallet.publicKey.toString() && <button onClick={() => likeHandler(tweet.author || tweet.account.author)}><img src={NotLikedIcon} alt="heart"></img></button>}
                          <span className="pl-1">{like > 0 && like}</span>
                        </div>
                      )
                    })

                  } */}
                </div>
              </div>
            );
          })}


        {props.homePage && (
          <div className="border-b-2 border-b-gray-300 px-2 py-1 flex justify-center">
            <button
              onClick={loadMoreHandler}
              className="bg-blue-400 font-medium text-white p-2 self-center hover:bg-blue-500 rounded-md w-28 my-4 text-sm md:text-base"
            >
              Load More
            </button>
          </div>
        )}
      </section>
    </>
  );
};

export default TweetsContainer;
